import { BASE_URL, AES_KEY } from "../../config";
import Cookies from "js-cookie";
import AES256 from "aes-everywhere";
import { SET_ERROR_STATE, SET_LOGIN_STATE, RESET_STATUS_STATE, REQUEST_STATE, REQUEST_DONE, REQUEST_PAGE_STATE, SET_PROFILE } from "../../utils/constants/actionTypes";
import Logout from "./Logout";
import publicIp from "public-ip";
import { URenewToken } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";

const CheckTokenBlacklist = async (token, tokenRefresh, cb) => {
	try {
		let res = await fetch(`${BASE_URL}/authentication/introspect`, {
			method: "POST",
			credentials: "include",
			headers: {
				"X-Refresh-Token": tokenRefresh,
				"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
			},
			body: `token=${token}&token_type_hint=access_token`,
		});

		let hasil = await res.json();
		console.log(hasil);
		cb(hasil["result"] ? hasil["result"]["active"] : false, null);
	} catch (err) {
		cb(false, err);
	}
};

export default (cb, isPage) => async (dispatch) => {
	isPage && dispatch({ type: REQUEST_PAGE_STATE });
	dispatch({ type: RESET_STATUS_STATE });
	dispatch({ type: REQUEST_STATE });
	try {
		/*
			a = kc_id || b = kc_rid
			c = decode decrypt kc_id
			d = decode decrypt kc_rid
			expa = exp a dikurangi 1 menit
			expr = exp b
			day = waktu saat ini
			api = api refresh
		*/

		//ambil token a dan b
		let payload;
		var tokenPayload = await Cookies.get("_kc_id");
		var tokenRenew = await Cookies.get("_kc_rid");

		//lalu cek decrypt dari keduanya
		var tokenRenewDecr = await AES256.decrypt(tokenRenew, AES_KEY);
		if (tokenPayload) {
			var tokenPayloadDecr = await AES256.decrypt(tokenPayload, AES_KEY);
			payload = await JSON.parse(atob(tokenPayloadDecr.split(".")[1]));
		} else {
			payload = {};
		}

		//kalo valid lanjut cek expa
		try {
			let expPayload = payload.exp;
			const day = Math.round(new Date() / 1000);
			if (day <= expPayload - 60) {
				// kalo day kurang dari expa check token c blacklist
				CheckTokenBlacklist(tokenPayloadDecr, tokenRenewDecr, (status, err) => {
					// check token blacklist error
					if (err) {
						dispatch({ type: SET_ERROR_STATE, payload: err.message });
					} else {
						// check token blacklist status 200 kirim callback isinya c
						if (status) {
							dispatch({ type: SET_LOGIN_STATE, payload: true });
							dispatch({ type: REQUEST_DONE });
							cb(tokenPayloadDecr);
						} else {
							// check token status 401 masuk ke logout ( token terblacklist )
							dispatch({ type: SET_LOGIN_STATE, payload: false });
							dispatch({ type: REQUEST_DONE });
							cb(null);
							Logout();
						}
					}
				});
			} else {
				// kalo day lebih atau sama dengan expa cek b
				// kalo day kurang dari expr maka call api
				if (tokenRenewDecr) {
					let res = await fetch(`${BASE_URL}${URenewToken}`, {
						method: "POST",
						credentials: "include",
						headers: {
							// decr b di set ke  'X-Refresh-Token'
							"X-Refresh-Token": tokenRenewDecr,
							"X-Device-IP": await publicIp.v4(),
							"X-Device-Name": "sjdh",
						},
						body: JSON.stringify({}),
					});
					let hasil = await res.json();
					if (res.status === 200) {
						// kalo 200 get b ulang, decr hasilnya dikasih ke callback d yang barunya
						tokenPayload = Cookies.get("_kc_id");
						tokenPayloadDecr = AES256.decrypt(tokenPayload, AES_KEY);
						dispatch({ type: SET_LOGIN_STATE, payload: true });
						dispatch({ type: REQUEST_DONE });
						cb(tokenPayloadDecr);
					} else if (res.status === 401) {
						// kalo 401 langsung ke logout
						dispatch({ type: SET_LOGIN_STATE, payload: false });
						dispatch({ type: REQUEST_DONE });
						bugsnagClient.notify(new Error(`RefreshToken.js/ (line 127) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
						cb(null);
						Logout();
					} else {
						// masukin ke pesan error
						// dispatch({ type: SET_LOGIN_STATE, payload: true})
						dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });
						bugsnagClient.notify(new Error(`RefreshToken.js/ (line 134) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
						cb(null);
					}
				} else {
					// kalo day lebih atau sama dengan expr langsung logout
					dispatch({ type: SET_LOGIN_STATE, payload: false });
					dispatch({ type: REQUEST_DONE });
					cb(null);
					Logout();
				}
			}
		} catch (err) {
			// dispatch({ type: SET_LOGIN_STATE, payload: true})
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
			bugsnagClient.notify(new Error(`RefreshToken.js/ (line 149) ===> catch - ${err.message}`));

			cb(null);
		}
	} catch (err) {
		//kalo tidak valid langsung ke logout
		dispatch({ type: SET_LOGIN_STATE, payload: false });
		dispatch({ type: REQUEST_DONE });
		bugsnagClient.notify(new Error(`RefreshToken.js/ (line 157) ===> catch - ${err.message}`));
		cb(null);
		Logout();
	}
};
